module.exports = __webpack_public_path__ + "img/buildSite-default.5bb77957.png";